import { i18n } from 'app/utils/i18n';
import { NewDropdown } from 'app/components/ui';

export type TaggingSubMode = 'tag' | 'mark-coverage';

interface TaggingSubModePickerProps {
  currentValue: TaggingSubMode;
  onChange: (value: TaggingSubMode) => void;
}

export const TaggingSubModePicker = ({ currentValue, onChange }: TaggingSubModePickerProps) => {
  const options = [
    {
      label: i18n('tag.coverage.submode.tag.label'),
      value: 'tag',
      icon: <i className="fa-regular fa-lg fa-tag" />,
    },
    {
      label: i18n('tag.coverage.submode.markCoverage.label'),
      value: 'mark-coverage',
      icon: <i className="fa-regular fa-lg fa-highlighter" />,
    },
  ];

  return <NewDropdown variant="rounded" currentValue={currentValue} options={options} onUpdate={(value) => onChange(value as TaggingSubMode)} />;
};
